<procure-input-range
  [label]="label()"
  [min]="min()"
  [max]="max()"
  [step]="step()"
  [group]="control()"
/>
